export default __webpack_public_path__ + "static/media/pattern001.4e44610a.mp3";